<template>
  <div class='single-scramble'>
    <h2 :style="{textAlign: 'left'}">{{ scramble }}</h2>
    <div v-html='previewHTML'></div>
  </div>
</template>

<script>
import { CubePreview } from 'cube-preview'
import {twoScrambleToSVG, fourScrambleToSVG, fiveScrambleToSVG, pyraScrambleToSVG, skewbScrambleToSVG, ftoScrambleToSVG, skewb_image, fto_image, image_4x4, image_5x5} from '@/modules/scramble-state'
import Cube from 'cubejs'
const scrambleTypeNames = {
  '3x3': '333',
  '3BLD': '333',
  '2x2': '222',
  '4x4': '444',
  '5x5': '555',
  'Pyraminx': 'pyram',
  'Skewb': 'skewb',
  'FTO': 'fto',
}

export default {
  name: 'single-scramble',
  props: {
    scramble: String,
    type: String
  },
  computed: {
    previewHTML () {
      try {
        const type = scrambleTypeNames[this.type || '3x3']
        if (type === undefined) {
          return 'Cannot preview scramble for ' + this.type
        }
        if (type === 'pyram') {
          return new CubePreview().setType(type).setCubieSize(30).setSpacing(10).svgString(pyraScrambleToSVG(this.scramble))
        } else if (type === 'skewb') {
          return skewb_image(skewbScrambleToSVG(this.scramble)).outerHTML
        } else if (type === '222') {
          return new CubePreview().setType(type).svgString(twoScrambleToSVG(this.scramble))
        } else if (type === '444') {
          return image_4x4(fourScrambleToSVG(this.scramble)).outerHTML
        } else if (type === '555') {
          return image_5x5(fiveScrambleToSVG(this.scramble)).outerHTML
        } else if (type === 'fto') {
          return `<div style='transform: scale(1.0)'>${fto_image(ftoScrambleToSVG(this.scramble), ['white', 'purple', 'red', 'green', 'darkgray', 'blue', 'orange', 'yellow'])}</div>`
        } else {
          const cube = new Cube()
          if (this.scramble) {
            cube.move(this.scramble)
          }
          return new CubePreview().setType(type).svgString(cube.asString())
        }
      } catch (e) {
        return 'Error when generating preview: ' + e
      }
    }
  }
}
</script>

<style>

</style>
